import { Box, Tooltip } from "@mantine/core";
import { pluralize } from "#app/utils/pluralize.ts";
import { RedCard, YellowCard } from "./card";

type Props = {
  type: "red" | "yellow";
  count: number | null | undefined;
  withTooltip?: boolean;
};

export function CardTotal({ type, count, withTooltip = false }: Props) {
  return count ? (
    <Tooltip
      label={`${count} ${type} ${pluralize("card", count)}`}
      disabled={!withTooltip}
    >
      <Box ml={4}>{type === "yellow" ? <YellowCard /> : <RedCard />}</Box>
    </Tooltip>
  ) : null;
}
